import { useContext } from "react";
import { ActiveReportContext } from "../context/ReportContext";

const useActiveReport = (params?: { gracefulError?: boolean }) => {
  const context = useContext(ActiveReportContext);
  const { data, isLoading, error } = context || {};

  // console.log("context123", context);

  // @ts-ignore
  window.reportContext = context;

  // This must go before throwing the error, to allow reports to load.
  if (isLoading) {
    return;
  }

  // Throw an error if there is one. This can be caught by an error boundary or similar higher up in the component tree.
  if (error) {
    if (params?.gracefulError) return;
    throw error;
  }

  // Return the data and the loading state. This way, the components using this hook can handle the loading state as they prefer.
  return data;
};

export default useActiveReport;
